import { render, staticRenderFns } from "./LocationDetailsTab.vue?vue&type=template&id=6564b93f&scoped=true&"
import script from "./LocationDetailsTab.vue?vue&type=script&lang=ts&"
export * from "./LocationDetailsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6564b93f",
  null
  
)

export default component.exports